import { render } from "./ProductNavbar.vue?vue&type=template&id=3f4583ca&scoped=true"
import script from "./ProductNavbar.vue?vue&type=script&lang=js"
export * from "./ProductNavbar.vue?vue&type=script&lang=js"

import "./ProductNavbar.vue?vue&type=style&index=0&id=3f4583ca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f4583ca"]])

export default __exports__